import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import notification from "../../../images/notifications_white.svg";
import { notify } from "react-notify-toast";
import { bindActionCreators } from "redux";
import { actionOrderDetails } from "../../../actions/index";
class Sodexo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const collectable_sodexo = this.props.orderData.orderData
      .collectable_sodexo;
    if (!collectable_sodexo) {
      document.getElementById("no_sodexo").disabled = true;
      document.getElementById("no_sodexo").checked = true;
      document.getElementById("yes_sodexo").disabled = true;
      document.getElementById("sodexo-amount").readOnly = true;
      document.getElementById("sodexo-amount").value = "0.00";
      this.noSodexoAmount = true;
      //document.getElementById('no_sodexo').checked=true;
    }
  }
  checkRemainingAmount(collectable_sodexo, e) {
    const SodexoAmount = parseInt(
      document.getElementById("sodexo-amount").value
    );
    const radioSodexo = document.getElementById("yes_sodexo").checked;
    const tripdata = Object.assign({}, this.props.orderData);
    tripdata.orderData.amountCollect =
      parseInt(tripdata.orderData.amountToBe_collected_cal) + ".00";
    if (radioSodexo || this.noSodexoAmount) {
      if (SodexoAmount > collectable_sodexo) {
        notify.show("Please Select Eligible Sodexo Amount", "error", 1000);
        e.preventDefault();
      } else {
        tripdata.orderData.sodexo_amount = SodexoAmount;
        tripdata.orderData.amountCollect =
          parseInt(tripdata.orderData.amountCollect) - SodexoAmount + ".00";
      }
    }
    this.props.actionOrderDetails(tripdata);
    localStorage.setItem("orderData", JSON.stringify(tripdata));
  }
  radioInput(bool) {
    document.getElementById("sodexo-amount").readOnly = bool;
  }
  render() {
    const collectable_sodexo = this.props.orderData.orderData
      .collectable_sodexo;
    return (
      <div className="container mw-100">
        <div className="rider-header position-fixed deliver-custom-header">
          <div className="header-left-side">
            <div>
              <NavLink to="/deliveryorder">
                <i className="text-white float-left pt-1 pr-3 icon-prevarrow back-btn-arrow"></i>
              </NavLink>
              <span className="text-white hub-header-title">Order Details</span>
              <img
                className="float-right pt-1"
                // src={notification}
                // alt="notification"
              />
            </div>
          </div>
        </div>
        <div className="maincontent deliver-order-comp sodexo_container">
          <p className="sodexo_label pt-3">
            Do you want to use <span className="ucase">Sodexo/Eden Red?</span>
          </p>
          <div className="sodexo_radio_container p-3">
            <div className="sodexo_radio_inner">
              <span className="float-left">
                <input
                  onClick={(e) => this.radioInput(false)}
                  className="with-gap custom-check"
                  name="return_reason"
                  defaultChecked
                  id="yes_sodexo"
                  type="radio"
                />
                <label htmlFor="yes_sodexo">YES</label>
              </span>
              <span className="float-right">
                <input
                  onClick={(e) => this.radioInput(true)}
                  className="with-gap custom-check"
                  name="return_reason"
                  id="no_sodexo"
                  type="radio"
                />
                <label htmlFor="no_sodexo">NO</label>
              </span>
            </div>
          </div>
          <div className="sodexo_amount_input px-5 py-3">
            <input
              type="number"
              onKeyDown={(e) =>
                (e.keyCode > 47 && e.keyCode < 58) || e.keyCode === 8
                  ? ""
                  : e.preventDefault()
              }
              id="sodexo-amount"
              defaultValue={`${parseInt(collectable_sodexo)}`}
            />
          </div>
          <div className="sodexo_btn_container">
            <NavLink
              className="sodexo_continue_btn"
              to="/paymentcardcash"
              onClick={(e) => this.checkRemainingAmount(collectable_sodexo, e)}
            >
              Continue
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    orderData: state.orderDetails,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { actionOrderDetails: actionOrderDetails },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(Sodexo);



// WEBPACK FOOTER //
// ./src/components/Intransit/Payment/Sodexo.js